// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__14dQW","content":"Consent_content__3yTIY","footer":"Consent_footer__21Xs4"};